
export default function getGridColSpanXl(span) {
  switch(span) {
    case 1:
      return "xl:col-span-1";
    case 2:
      return "xl:col-span-2";
    case 3:
      return "xl:col-span-3";
    case 4:
      return "xl:col-span-4";
    case 5:
      return "xl:col-span-5";
    case 6:
      return "xl:col-span-6";
    case 7:
      return "xl:col-span-7";
    case 8:
      return "xl:col-span-8";
    case 9:
      return "xl:col-span-9";
    case 10:
      return "xl:col-span-10";
    case 11:
      return "xl:col-span-11";
    case 12:
      return "xl:col-span-12";
    case "auto":
      return "xl:col-auto";
    case "full":
      return "xl:col-span-full";
  }
}